import React, { useState, useEffect } from "react";
import { getAllCategories } from "../../../utils/API/getAllCategories";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

const Category = ({ onSelectCategory, selectedCategory }) => {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categories = await getAllCategories(dispatch);
        setCategories(categories);
      } catch (error) {
        toast.error("Error fetching categories");
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="pb-2 ml-3 mb-2">
      <select
        id="category"
        value={selectedCategory}
        onChange={onSelectCategory}
        className="bg-white w-full text-xs text-grey-700 py-1 pl-3 leading-normal font-normal border border-gray-300 rounded-lg focus:outline-none"
      >
        <option value="" hidden>
          Select the category
        </option>
        {categories.map((category) => (
          <option key={category._id} value={category._id}>
            {category.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Category;
